module.exports = __webpack_public_path__ + "img/TL.ed647470.png";